// Collection color swatches - fetch product data on click
// Prefetch on hover for instant feel

// Apply swatch colors from the metaobject JSON blob (avoids per-product Liquid lookups)
function applyCollectionSwatchColors() {
  const dataEl = document.getElementById('swatch-data');
  if (!dataEl) return;

  let swatchData;
  try { swatchData = JSON.parse(dataEl.textContent); } catch(e) { return; }

  const colorMap = {};
  (swatchData.colors || []).forEach(function(obj) {
    var key = Object.keys(obj)[0];
    colorMap[key.toLowerCase().replace(/[\s-]/g, '')] = obj[key];
  });

  document.querySelectorAll('.product__colors-swatch-link[data-swatch-color]').forEach(function(el) {
    var raw = el.getAttribute('data-swatch-color').trim();
    var name = raw.toLowerCase().replace(/[\s-]/g, '');
    var value = colorMap[name];
    if (!value) { el.style.background = raw || '#E5E5E5'; return; }
    if (/\.(jpe?g|png|svg)/.test(value)) {
      el.style.background = 'url(' + value + ')';
      el.style.backgroundSize = 'cover';
      el.style.backgroundPosition = 'center center';
    } else {
      el.style.background = value;
    }
  });
}

document.addEventListener('DOMContentLoaded', applyCollectionSwatchColors);

const swatchCache = {};

// Prefetch product data on hover
function prefetchProduct(handle) {
  if (swatchCache[handle]) return;
  swatchCache[handle] = fetch(`/products/${handle}.js`)
    .then(r => r.json())
    .then(data => { swatchCache[handle] = data; return data; })
    .catch(() => { delete swatchCache[handle]; });
}

// Get product data (from cache or fetch)
function getProductData(handle) {
  const cached = swatchCache[handle];
  if (cached && cached.title) return Promise.resolve(cached);
  if (cached && cached.then) return cached;
  return prefetchProduct(handle);
}

// Find the product image URL from images array
function findProductImage(images) {
  const productImg = images.find(url => url.includes('product-img'));
  return productImg || images[0] || '';
}

// Append width param to Shopify CDN URL
function sizedUrl(url, width) {
  if (!url) return '';
  // Handle both old and new Shopify CDN URL formats
  if (url.includes('?')) {
    return url + '&width=' + width;
  }
  return url + '?width=' + width;
}

// Use event delegation - single listener on the grid
document.addEventListener('DOMContentLoaded', function() {
  const grid = document.querySelector('#CollectionLoop');
  if (!grid) return;

  // Prefetch on hover
  grid.addEventListener('mouseenter', function(e) {
    const swatch = e.target.closest('.product__colors-swatch');
    if (!swatch) return;
    const handle = swatch.getAttribute('data-variant-handle');
    if (handle) prefetchProduct(handle);
  }, true);

  // Handle click
  grid.addEventListener('click', function(e) {
    const swatch = e.target.closest('.product__colors-swatch');
    if (!swatch) return;

    e.preventDefault();
    e.stopPropagation();

    const handle = swatch.getAttribute('data-variant-handle');
    const productUrl = swatch.getAttribute('data-product-url');
    if (!handle) return;

    const productItem = swatch.closest('[data-product-grid-item]');
    if (!productItem) return;

    // Update active swatch immediately (no fetch needed)
    const allSwatchLinks = swatch.closest('.product__colors').querySelectorAll('.product__colors-swatch-link');
    allSwatchLinks.forEach(s => s.classList.remove('active-swatch'));
    const swatchLink = swatch.querySelector('.product__colors-swatch-link');
    if (swatchLink) swatchLink.classList.add('active-swatch');

    // Update URL immediately
    const productLinks = productItem.querySelectorAll('[data-product-link]');
    productLinks.forEach(link => link.setAttribute('href', productUrl));

    // Always hide video when a swatch is clicked
    const videoContainer = productItem.querySelector('.product-video-container');
    if (videoContainer) {
      videoContainer.classList.remove('active');
      videoContainer.style.display = 'none';
      videoContainer.innerHTML = '';
    }

    // Always hide lifestyle image when a swatch is clicked
    const lifestyleContainer = productItem.querySelector('.product-item__bg__under.product-lifestyle-image');
    if (lifestyleContainer) {
      lifestyleContainer.classList.remove('active');
      lifestyleContainer.style.setProperty('opacity', '0', 'important');
    }

    // Always show the product image gallery
    const galleryContainer = productItem.querySelector('.product-item__gallery');
    if (galleryContainer) galleryContainer.classList.add('active_index');

    // Fetch and update product data
    getProductData(handle).then(data => {
      if (!data || !data.title) return;

      updateTitle(productItem, data);
      updateMainImage(productItem, data);
      updateGallery(productItem, data);
      updatePrice(productItem, data);
      updateBadges(productItem, data);
      updateAtcButton(productItem, data);
    });
  });
});

function updateTitle(el, data) {
  const title = el.querySelector('.product-item__title');
  if (title) title.textContent = data.title;
}

function updateMainImage(el, data) {
  const mainContainer = el.querySelector('[data-product-image-default]');
  const galleryContainer = el.querySelector('.product-item__gallery');
  if (!mainContainer) return;

  // Show gallery, hide main static image
  if (galleryContainer) galleryContainer.classList.add('active_index');
  mainContainer.classList.remove('active_index');

  const imgUrl = findProductImage(data.images);
  const sized = sizedUrl(imgUrl, 800);

  mainContainer.setAttribute('data-product-image', sized);

  const img = mainContainer.querySelector('img');
  if (img) {
    img.src = sized;
    img.srcset = '';
  }
}

function updateGallery(el, data) {
  const gallery = el.querySelector('.product-item__gallery');
  if (!gallery) return;

  // Filter to max 5 images
  const images = (data.images || []).slice(0, 5);
  const existing = gallery.querySelectorAll('.product-item__gallery-image');

  // Remove all active states
  existing.forEach(img => img.classList.remove('active'));

  images.forEach((imgUrl, i) => {
    const sized = sizedUrl(imgUrl, 800);
    let slot = gallery.querySelector(`[data-product-gallery-image="${i}"]`);

    if (slot) {
      // Update existing slot
      slot.style.display = '';
      slot.classList.remove('gallery-image--deferred');
      const img = slot.querySelector('img');
      if (img) {
        img.src = sized;
        img.srcset = '';
        img.alt = data.title || '';
      } else {
        // Slot was deferred, create img
        const wrapper = document.createElement('div');
        wrapper.className = 'image-wrapper lazy-image';
        const newImg = document.createElement('img');
        newImg.src = sized;
        newImg.alt = data.title || '';
        newImg.className = 'image__img';
        newImg.loading = 'lazy';
        wrapper.appendChild(newImg);
        slot.appendChild(wrapper);
      }
    } else {
      // Create new slot
      slot = document.createElement('div');
      slot.className = 'product-item__gallery-image';
      slot.setAttribute('data-product-gallery-image', i);
      const wrapper = document.createElement('div');
      wrapper.className = 'image-wrapper lazy-image';
      const newImg = document.createElement('img');
      newImg.src = sized;
      newImg.alt = data.title || '';
      newImg.className = 'image__img';
      newImg.loading = 'lazy';
      wrapper.appendChild(newImg);
      slot.appendChild(wrapper);
      gallery.appendChild(slot);
    }

    if (i === 0) slot.classList.add('active');
  });

  // Hide extra slots
  for (let i = images.length; i < existing.length; i++) {
    const extra = gallery.querySelector(`[data-product-gallery-image="${i}"]`);
    if (extra) extra.style.display = 'none';
  }
}

// Strip AUD currency code from formatted price, keep all others (USD, NZD, etc.)
function stripAud(price) {
  var currency = typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active;
  if (currency === 'AUD') {
    return price.replace(/\s*AUD\s*/g, '');
  }
  return price;
}

function updatePrice(el, data) {
  const priceEl = el.querySelector('[data-product-price] .price');
  if (!priceEl) return;

  const variant = data.variants && data.variants[0];
  if (!variant) return;

  if (variant.available) {
    const formatted = stripAud(typeof themeCurrency !== 'undefined' && typeof theme !== 'undefined'
      ? themeCurrency.formatMoney(variant.price, theme.moneyFormat)
      : ('$' + (variant.price / 100).toFixed(2)));

    let html = `<span class="new-price">${formatted}</span>`;
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      const compareFormatted = stripAud(typeof themeCurrency !== 'undefined' && typeof theme !== 'undefined'
        ? themeCurrency.formatMoney(variant.compare_at_price, theme.moneyFormat)
        : ('$' + (variant.compare_at_price / 100).toFixed(2)));
      html = `<span class="new-price sale">${formatted}</span><span class="old-price">${compareFormatted}</span>`;
    }
    priceEl.innerHTML = html;
  } else {
    priceEl.innerHTML = '<span class="sold-out">Sold Out</span>';
  }
}

function updateBadges(el, data) {
  const badgeBox = el.querySelector('.product-item__image > .badge-boxes');
  if (!badgeBox) return;

  const variant = data.variants && data.variants[0];
  const tags = data.tags || [];

  badgeBox.innerHTML = '';

  if (variant && !variant.available) {
    badgeBox.innerHTML = '<div class="badge">Sold Out</div>';
    const atc = el.querySelector('quick-add-product');
    if (atc) atc.style.display = 'none';
    return;
  }

  // Show ATC if available
  const atc = el.querySelector('quick-add-product');
  if (atc) atc.style.display = 'block';

  // Sale badge
  if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
    badgeBox.innerHTML += '<div class="sale-box badge">Sale</div>';
  }

  // Preorder badge
  if (tags.includes('_preorder')) {
    badgeBox.innerHTML += '<div class="preorder-box badge">Pre-order</div>';
  }

  // Custom label badges
  tags.forEach(tag => {
    if (tag.startsWith('label: ')) {
      const label = tag.replace('label: ', '');
      badgeBox.innerHTML += `<div class="badge-box badge">${label}</div>`;
    }
  });
}

function updateAtcButton(el, data) {
  const atcBtn = el.querySelector('.quick-add__button');
  if (!atcBtn) return;

  const variant = data.variants && data.variants[0];
  if (variant) {
    atcBtn.dataset.quickAddVariant = variant.id;
    atcBtn.dataset.variantHandle = data.handle;
  }

  // Update button text based on preorder status
  const btnText = atcBtn.querySelector('.btn__text');
  if (!btnText) return;

  const tags = data.tags || [];
  const isPreorder = tags.includes('_preorder');
  const preorderDate = variant && variant.metafields && variant.metafields.custom && variant.metafields.custom.preorder_date;

  if (isPreorder && preorderDate) {
    btnText.innerHTML = 'PRE ORDER NOW,<br>SHIPPED ' + preorderDate;
  } else if (isPreorder) {
    btnText.textContent = 'PRE ORDER NOW';
  } else {
    btnText.textContent = 'Quick add';
  }
}
